module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}\nconst employeeID = employee.employeeID\nconst meta = resourceData.meta || {}\nconst project = meta.project || {}\nconst showAllProjectTerms = meta.showAllProjectTerms && helpers.hasRoleInScope('office')\nconst isAdvertisement = config.isAdvertisement || false\nconst term = (resourceData.data || {}).attributes || {}\nconst jobs = term.jobs || {}\nconst myJobs = Object.values(term.myJobs || {}).sort((a, b) => a.timeIndex - b.timeIndex)\nconst nrOfMyJobs = utils.collectionSize(myJobs)\nconst status = term.myLeastJobStatus || {}\nstatus.statusOutDated = status.statusOutDated || term.nrOfMyNullJobStatus > 0\nconst isInPast = term.isInPast\nconst managers = term.managers || []\nconst manager = managers[0]\nconst infoForManager = term.infoForManager\nconst infoForAll = term.infoForAll\nconst contactPerson = term.contactPerson || {}\nconst locationUrl = term.locationUrl || term.locationGeneratedUrl\nconst customer = term.customer || {}\nlet isManager = employee.isManager || showAllProjectTerms\nconst skills = []\nconst projectTermJobIDs = {}\nfor(const myJob of myJobs){\nconst job = myJob.job || {}\nisManager = isManager || job.isManager || myJob.isManager\nif(myJob.projectTermJobID){\nprojectTermJobIDs[myJob.projectTermJobID] = true\n}\nif(myJob.skills){\nskills.push(myJob.skills)\n}\n}\n%><div data-project-term-id=\"<%= term.projectTermID %>\" data-project-term-job-ids=\"<%= Object.keys(projectTermJobIDs).join(',') %>\"><%\nif(!isAdvertisement){\n%><div class=\"head\"><%\n%><h1><%= `#${term.projectTermID} - ${term.title || 'Termin'}` %></h1><%\n%><div class=\"buttons\"><%\nif(isManager && (term.isLastProjectsTermInShippingOrderGroup || term.hasShippingOrder) && !project.isInternal){\n// TODO: shipping order proxy thingy\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'shippingOrders', mode: 'projectTerm', symbolOnly: true }}) %><%\n}\nif(isManager && !project.isInternal){\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'timeRecordings_projectTerm', symbolOnly: true }}) %><%\n}\n%></div><%\n%></div><%\n}\n%><ul><%\nif(!isAdvertisement && isManager) {\nif(contactPerson.name || contactPerson.tel || contactPerson.mobile) {\n%><li><%\n%><%- include('./viewerField', { model: { contactPerson, labelKey: 'projects.crewTermViewer.fields.contact.name', showDetails: true }}) %><%\n%></li><%\n}\nif(infoForManager) {\nconst buttons = [{\nbuttonType: 'showFullText',\nicon: 'fi fi-exclamation-circle',\nsymbolOnly: true,\n}]\n%><li><%\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.infoForManager.name', text: infoForManager, buttons }}) %><%\n%></li><%\n}\n}\nif(!isAdvertisement && infoForAll) {\nconst buttons = [{\nbuttonType: 'showFullText',\nicon: 'fi fi-exclamation-circle',\nsymbolOnly: true,\n}]\n%><li><%\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.infoForAll.name', text: infoForAll, buttons }}) %><%\n%></li><%\n}\nfor(const myJob of myJobs){\nconst showTime = myJob.showTime || {}\nconst job = myJob.job || {}\nif(showTime.time || job.code) {\n%><li class=\"jobTime\"><%\nif(job.code) {\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.job.name', name: job.code, additionalClass: 'isJob' }}) %><%\n}\nif(showTime.time) {\nlet nameKey = 'projects.crewTermViewer.fields.time.valueFull'\nif(!showTime.endTS){\nnameKey = 'projects.crewTermViewer.fields.time.value'\n}\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.time.name', name: storage.__(nameKey, { time: showTime.time, duration: utils.number.format(showTime.duration, undefined, 'float').formatted }) }}) %><%\n}\n%></li><%\n}\n}\nif(locationUrl) {\n%><li><%\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.location.name', location: { name: term.location, url: locationUrl }, multilineGranted: true }}) %><%\n%></li><%\n}\nif(skills.length) {\n%><li><%\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.skills.name', name: skills.join(',\\n'), multilineGranted: true }}) %><%\n%></li><%\n}\nif(term.catering !== undefined && term.catering !== null){\n%><li><%\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.catering.name', name: storage.__(`dataValues.boolean.${term.catering || 0}`) }}) %><%\n%></li><%\n}\nif(!isAdvertisement && manager) {\n%><li><%\n%><%- include('./viewerField', { model: { nicknamePerson: manager, labelKey: 'projects.crewViewer.fields.manager.name', showDetails: true }}) %><%\n%></li><%\n}\nif(!isAdvertisement) {\n%><li><%\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.colleagues.name', colleagues: { employeeID, jobs: term.jobs }, showDetails: isManager }}) %><%\n%></li><%\n}\nif(isAdvertisement && customer.companyName) {\n%><li><%\n%><%- include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.customer.name', name: customer.companyName }}) %><%\n%></li><%\n}\n%></ul><%\n%><div class=\"footer\"><%\n%><div class=\"lastCoreUpdate\"><div><%\nif(term.maxLastCoreUpdateAt){\nconst m = utils.moment(term.maxLastCoreUpdateAt)\n%><%= storage.__('projects.crewTermViewer.lastCoreUpdate', { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm:ss') }) %><%\n}\n%></div></div><%\nif(!isInPast && nrOfMyJobs > 0){\nconst buttonContainerClasses = ['buttons']\nif(employee.type === 'internal'){\nbuttonContainerClasses.push('singleButton')\n}\n%><div class=\"<%- buttonContainerClasses.join(' ') %>\"><%\n// let icon = 'fi fi-circle-question'\n// let positive\n// // let buttonType = 'edit'\n//\n// const buttons = {\n//     internal: {\n//         read: {\n//             statusNotActive: {\n//                 icon: 'fi fi-circle-question',\n//             },\n//             statusActive: {\n//                 icon: 'fi fi-check',\n//                 positive: true\n//             },\n//         },\n//     },\n//     external: {\n//         agreed: {\n//\n//         },\n//         revoked: false,\n//         applied: false,\n//         waitlisted: false,\n//     },\n//     contractor: {\n//         agreed: false,\n//         revoked: false,\n//     }\n// }\n//\n// // if(status.status){\n// //     // buttonType = 'alreadyEdited'\n// //     showButtons[status.status] = 'alreadyEdited'\n// // }\n//\n// if(employee.type === 'internal'){\n//     showButtons.read = 'edit'\n//\n//     if(status.status === 'read'){\n//         icon = 'fi fi-check'\n//         positive = true\n//     }\n// } else if(employee.type === 'external'){\n//     // TODO: complete this list when external status in not myJob is fixed\n//     showButtons.revoked = true\n//\n//     if(status.status === 'agreed'){\n//         icon = 'fi fi-check-double'\n//         positive = true\n//     } else if(status.status === 'revoked'){\n//         icon = 'fi fi-ban'\n//     } else if(status.status === 'applied'){\n//         icon = 'fi fi-check'\n//         positive = true\n//     } else if(status.status === 'waitlisted'){\n//         icon = 'fi fi-check'\n//         positive = true\n//     }\n// } else if(contractor.contractorID){\n//     showButtons.agreed = true\n//     showButtons.revoked = true\n//\n//     if(status.status === 'agreed'){\n//         icon = 'fi fi-check'\n//         positive = true\n//     } else if(status.status === 'revoked'){\n//         icon = 'fi fi-ban'\n//     }\n// }\n// if(status.status){\n//     icon = 'fi fi-check'\n//     positive = true\n// }\n// if(status.status === 'read'){\n//\n// }\n// if(status.status){\n//     // buttonType = 'alreadyEdited'\n//     showButtons[status.status] = 'alreadyEdited'\n// }\nif(isAdvertisement){\nif(employee.type === 'external' || employee.type === 'occasional'){\nlet buttonType = ''\nlet buttonFormMapping = { negative: false }\nif(status.status !== 'revoked' || status.statusOutDated){\nbuttonType = 'edit'\n} else {\nbuttonType = 'alreadyEdited'\nbuttonFormMapping = { negative: true }\n}\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType, context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoke', ...buttonFormMapping }}) %><%\nif(term.nextPositiveStatus){\nbuttonFormMapping = { positive: false }\nif(status.status !== term.nextPositiveStatus || status.statusOutDated){\nbuttonType = 'edit'\n} else {\nbuttonType = 'alreadyEdited'\nbuttonFormMapping = { positive: true }\n}\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType, context: 'projectTermJobStatus', mode: term.nextPositiveStatus, icon: `fi fi-${term.nextPositiveStatus}`, ...buttonFormMapping }}) %><%\n}\n}\n} else if(employee.type === 'internal'){\nif(status.status === 'read'){\nif(status.statusOutDated){\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'read', icon: 'fi fi-circle-question', additionalClass: 'statusOutDated' }}) %><%\n} else {\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'alreadyEdited', context: 'projectTermJobStatus', mode: 'read', icon: 'fi fi-check', positive: true }}) %><%\n}\n} else {\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'read', icon: 'fi fi-circle-question' }}) %><%\n}\n} else if(employee.type === 'external' || employee.type === 'occasional'){\nif(status.status === 'revoked'){\nif(status.statusOutDated){\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoked', additionalClass: 'statusOutDated' }}) %><%\n} else {\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'alreadyEdited', context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoked', negative: true }}) %><%\n}\n} else {\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoked' }}) %><%\n}\nif(status.status === 'agreed'){\nif(status.statusOutDated){\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'agreed', icon: 'fi fi-agreed', additionalClass: 'statusOutDated' }}) %><%\n} else {\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'alreadyEdited', context: 'projectTermJobStatus', mode: 'agreed', icon: 'fi fi-agreed', positive: true }}) %><%\n}\n} else {\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'agreed', icon: 'fi fi-agreed' }}) %><%\n}\n}\n// read, agreed, revoked, applied, waitlisted\n// <!--for(const s in showButtons){-->\n// <!--    const buttonProperties = showButtons[s]-->\n// <!--    if(buttonProperties){-->\n// <!--    }-->\n// <!--}-->\n%></div><%\n}\n%></div><%\n%></div>"
  , __filename = "components/templates/crew/projects/termViewer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}
const employeeID = employee.employeeID
const meta = resourceData.meta || {}
const project = meta.project || {}
const showAllProjectTerms = meta.showAllProjectTerms && helpers.hasRoleInScope('office')
const isAdvertisement = config.isAdvertisement || false
const term = (resourceData.data || {}).attributes || {}
const jobs = term.jobs || {}
const myJobs = Object.values(term.myJobs || {}).sort((a, b) => a.timeIndex - b.timeIndex)
const nrOfMyJobs = utils.collectionSize(myJobs)
const status = term.myLeastJobStatus || {}
status.statusOutDated = status.statusOutDated || term.nrOfMyNullJobStatus > 0
const isInPast = term.isInPast
const managers = term.managers || []
const manager = managers[0]
const infoForManager = term.infoForManager
const infoForAll = term.infoForAll
const contactPerson = term.contactPerson || {}
const locationUrl = term.locationUrl || term.locationGeneratedUrl
const customer = term.customer || {}
let isManager = employee.isManager || showAllProjectTerms
const skills = []
const projectTermJobIDs = {}
for(const myJob of myJobs){
const job = myJob.job || {}
isManager = isManager || job.isManager || myJob.isManager
if(myJob.projectTermJobID){
projectTermJobIDs[myJob.projectTermJobID] = true
}
if(myJob.skills){
skills.push(myJob.skills)
}
}

    ; __line = 35
    ; __append("<div data-project-term-id=\"")
    ; __append(escapeFn( term.projectTermID ))
    ; __append("\" data-project-term-job-ids=\"")
    ; __append(escapeFn( Object.keys(projectTermJobIDs).join(',') ))
    ; __append("\">")
    ; 
if(!isAdvertisement){

    ; __line = 37
    ; __append("<div class=\"head\">")
    ; 

    ; __line = 38
    ; __append("<h1>")
    ; __append(escapeFn( `#${term.projectTermID} - ${term.title || 'Termin'}` ))
    ; __append("</h1>")
    ; 

    ; __line = 39
    ; __append("<div class=\"buttons\">")
    ; 
if(isManager && (term.isLastProjectsTermInShippingOrderGroup || term.hasShippingOrder) && !project.isInternal){
// TODO: shipping order proxy thingy

    ; __line = 42
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'shippingOrders', mode: 'projectTerm', symbolOnly: true }}) )
    ; 
}
if(isManager && !project.isInternal){

    ; __line = 45
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'timeRecordings_projectTerm', symbolOnly: true }}) )
    ; 
}

    ; __line = 47
    ; __append("</div>")
    ; 

    ; __line = 48
    ; __append("</div>")
    ; 
}

    ; __line = 50
    ; __append("<ul>")
    ; 
if(!isAdvertisement && isManager) {
if(contactPerson.name || contactPerson.tel || contactPerson.mobile) {

    ; __line = 53
    ; __append("<li>")
    ; 

    ; __line = 54
    ; __append( include('./viewerField', { model: { contactPerson, labelKey: 'projects.crewTermViewer.fields.contact.name', showDetails: true }}) )
    ; 

    ; __line = 55
    ; __append("</li>")
    ; 
}
if(infoForManager) {
const buttons = [{
buttonType: 'showFullText',
icon: 'fi fi-exclamation-circle',
symbolOnly: true,
}]

    ; __line = 63
    ; __append("<li>")
    ; 

    ; __line = 64
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.infoForManager.name', text: infoForManager, buttons }}) )
    ; 

    ; __line = 65
    ; __append("</li>")
    ; 
}
}
if(!isAdvertisement && infoForAll) {
const buttons = [{
buttonType: 'showFullText',
icon: 'fi fi-exclamation-circle',
symbolOnly: true,
}]

    ; __line = 74
    ; __append("<li>")
    ; 

    ; __line = 75
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.infoForAll.name', text: infoForAll, buttons }}) )
    ; 

    ; __line = 76
    ; __append("</li>")
    ; 
}
for(const myJob of myJobs){
const showTime = myJob.showTime || {}
const job = myJob.job || {}
if(showTime.time || job.code) {

    ; __line = 82
    ; __append("<li class=\"jobTime\">")
    ; 
if(job.code) {

    ; __line = 84
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.job.name', name: job.code, additionalClass: 'isJob' }}) )
    ; 
}
if(showTime.time) {
let nameKey = 'projects.crewTermViewer.fields.time.valueFull'
if(!showTime.endTS){
nameKey = 'projects.crewTermViewer.fields.time.value'
}

    ; __line = 91
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.time.name', name: storage.__(nameKey, { time: showTime.time, duration: utils.number.format(showTime.duration, undefined, 'float').formatted }) }}) )
    ; 
}

    ; __line = 93
    ; __append("</li>")
    ; 
}
}
if(locationUrl) {

    ; __line = 97
    ; __append("<li>")
    ; 

    ; __line = 98
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.location.name', location: { name: term.location, url: locationUrl }, multilineGranted: true }}) )
    ; 

    ; __line = 99
    ; __append("</li>")
    ; 
}
if(skills.length) {

    ; __line = 102
    ; __append("<li>")
    ; 

    ; __line = 103
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.skills.name', name: skills.join(',\n'), multilineGranted: true }}) )
    ; 

    ; __line = 104
    ; __append("</li>")
    ; 
}
if(term.catering !== undefined && term.catering !== null){

    ; __line = 107
    ; __append("<li>")
    ; 

    ; __line = 108
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.catering.name', name: storage.__(`dataValues.boolean.${term.catering || 0}`) }}) )
    ; 

    ; __line = 109
    ; __append("</li>")
    ; 
}
if(!isAdvertisement && manager) {

    ; __line = 112
    ; __append("<li>")
    ; 

    ; __line = 113
    ; __append( include('./viewerField', { model: { nicknamePerson: manager, labelKey: 'projects.crewViewer.fields.manager.name', showDetails: true }}) )
    ; 

    ; __line = 114
    ; __append("</li>")
    ; 
}
if(!isAdvertisement) {

    ; __line = 117
    ; __append("<li>")
    ; 

    ; __line = 118
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.colleagues.name', colleagues: { employeeID, jobs: term.jobs }, showDetails: isManager }}) )
    ; 

    ; __line = 119
    ; __append("</li>")
    ; 
}
if(isAdvertisement && customer.companyName) {

    ; __line = 122
    ; __append("<li>")
    ; 

    ; __line = 123
    ; __append( include('./viewerField', { model: { labelKey: 'projects.crewTermViewer.fields.customer.name', name: customer.companyName }}) )
    ; 

    ; __line = 124
    ; __append("</li>")
    ; 
}

    ; __line = 126
    ; __append("</ul>")
    ; 

    ; __line = 127
    ; __append("<div class=\"footer\">")
    ; 

    ; __line = 128
    ; __append("<div class=\"lastCoreUpdate\"><div>")
    ; 
if(term.maxLastCoreUpdateAt){
const m = utils.moment(term.maxLastCoreUpdateAt)

    ; __line = 131
    ; __append(escapeFn( storage.__('projects.crewTermViewer.lastCoreUpdate', { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm:ss') }) ))
    ; 
}

    ; __line = 133
    ; __append("</div></div>")
    ; 
if(!isInPast && nrOfMyJobs > 0){
const buttonContainerClasses = ['buttons']
if(employee.type === 'internal'){
buttonContainerClasses.push('singleButton')
}

    ; __line = 139
    ; __append("<div class=\"")
    ; __append( buttonContainerClasses.join(' ') )
    ; __append("\">")
    ; 
// let icon = 'fi fi-circle-question'
// let positive
// // let buttonType = 'edit'
//
// const buttons = {
//     internal: {
//         read: {
//             statusNotActive: {
//                 icon: 'fi fi-circle-question',
//             },
//             statusActive: {
//                 icon: 'fi fi-check',
//                 positive: true
//             },
//         },
//     },
//     external: {
//         agreed: {
//
//         },
//         revoked: false,
//         applied: false,
//         waitlisted: false,
//     },
//     contractor: {
//         agreed: false,
//         revoked: false,
//     }
// }
//
// // if(status.status){
// //     // buttonType = 'alreadyEdited'
// //     showButtons[status.status] = 'alreadyEdited'
// // }
//
// if(employee.type === 'internal'){
//     showButtons.read = 'edit'
//
//     if(status.status === 'read'){
//         icon = 'fi fi-check'
//         positive = true
//     }
// } else if(employee.type === 'external'){
//     // TODO: complete this list when external status in not myJob is fixed
//     showButtons.revoked = true
//
//     if(status.status === 'agreed'){
//         icon = 'fi fi-check-double'
//         positive = true
//     } else if(status.status === 'revoked'){
//         icon = 'fi fi-ban'
//     } else if(status.status === 'applied'){
//         icon = 'fi fi-check'
//         positive = true
//     } else if(status.status === 'waitlisted'){
//         icon = 'fi fi-check'
//         positive = true
//     }
// } else if(contractor.contractorID){
//     showButtons.agreed = true
//     showButtons.revoked = true
//
//     if(status.status === 'agreed'){
//         icon = 'fi fi-check'
//         positive = true
//     } else if(status.status === 'revoked'){
//         icon = 'fi fi-ban'
//     }
// }
// if(status.status){
//     icon = 'fi fi-check'
//     positive = true
// }
// if(status.status === 'read'){
//
// }
// if(status.status){
//     // buttonType = 'alreadyEdited'
//     showButtons[status.status] = 'alreadyEdited'
// }
if(isAdvertisement){
if(employee.type === 'external' || employee.type === 'occasional'){
let buttonType = ''
let buttonFormMapping = { negative: false }
if(status.status !== 'revoked' || status.statusOutDated){
buttonType = 'edit'
} else {
buttonType = 'alreadyEdited'
buttonFormMapping = { negative: true }
}

    ; __line = 230
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType, context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoke', ...buttonFormMapping }}) )
    ; 
if(term.nextPositiveStatus){
buttonFormMapping = { positive: false }
if(status.status !== term.nextPositiveStatus || status.statusOutDated){
buttonType = 'edit'
} else {
buttonType = 'alreadyEdited'
buttonFormMapping = { positive: true }
}

    ; __line = 239
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType, context: 'projectTermJobStatus', mode: term.nextPositiveStatus, icon: `fi fi-${term.nextPositiveStatus}`, ...buttonFormMapping }}) )
    ; 
}
}
} else if(employee.type === 'internal'){
if(status.status === 'read'){
if(status.statusOutDated){

    ; __line = 245
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'read', icon: 'fi fi-circle-question', additionalClass: 'statusOutDated' }}) )
    ; 
} else {

    ; __line = 247
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'alreadyEdited', context: 'projectTermJobStatus', mode: 'read', icon: 'fi fi-check', positive: true }}) )
    ; 
}
} else {

    ; __line = 250
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'read', icon: 'fi fi-circle-question' }}) )
    ; 
}
} else if(employee.type === 'external' || employee.type === 'occasional'){
if(status.status === 'revoked'){
if(status.statusOutDated){

    ; __line = 255
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoked', additionalClass: 'statusOutDated' }}) )
    ; 
} else {

    ; __line = 257
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'alreadyEdited', context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoked', negative: true }}) )
    ; 
}
} else {

    ; __line = 260
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'revoked', icon: 'fi fi-revoked' }}) )
    ; 
}
if(status.status === 'agreed'){
if(status.statusOutDated){

    ; __line = 264
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'agreed', icon: 'fi fi-agreed', additionalClass: 'statusOutDated' }}) )
    ; 
} else {

    ; __line = 266
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'alreadyEdited', context: 'projectTermJobStatus', mode: 'agreed', icon: 'fi fi-agreed', positive: true }}) )
    ; 
}
} else {

    ; __line = 269
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'edit', context: 'projectTermJobStatus', mode: 'agreed', icon: 'fi fi-agreed' }}) )
    ; 
}
}
// read, agreed, revoked, applied, waitlisted
// <!--for(const s in showButtons){-->
// <!--    const buttonProperties = showButtons[s]-->
// <!--    if(buttonProperties){-->
// <!--    }-->
// <!--}-->

    ; __line = 278
    ; __append("</div>")
    ; 
}

    ; __line = 280
    ; __append("</div>")
    ; 

    ; __line = 281
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/projects/termViewer.ejs

}